export enum EOfferType {
    BUNDLE = 'Bundle',
    ROLLING_OFFER = 'RollingOffer',
    SPECIAL_OFFER = 'SpecialOffer',
    POP_UP = 'PopUp',
    PROGRESS_BAR = 'ProgressBar',
    ONE_PLUS_MANY = 'OnePlusMany',
}

export enum EPopupSubType {
    DAILY_BONUS = 'DailyBonus',
    POST_PURCHASE = 'PostPurchase',
    STORE_REFRESH = 'StoreRefresh',
    REWARD_CALENDAR = 'RewardCalendar',
}

export enum ESubRollingOfferCollectBehavior {
    DISAPPEAR = 'disappear',
    STAY = 'stay',
}

export enum ESaleDiscountDisplayType {
    PERCENTAGE = 'percentage',
    MULTIPLIER = 'multiplier',
    FIXED_AMOUNT = 'fixed_amount',
}
